import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { BatchingRules } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class BatchingRuleParamsEndpoints {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  get(req: BatchingRules.BatchingRuleParamsGetRequest = {}) {
    const params = convertRequestToParams(req);

    return this.http.get<BatchingRules.BatchingRuleParamsGetResponse>(
      `${this.env.constants.ADMIN_API_URL}/admin/batches/params`,
      {
        params,
      },
    );
  }
}

const convertRequestToParams = (request: BatchingRules.BatchingRuleParamsGetRequest): HttpParams => {
  let params = new HttpParams();

  // Helper to merge objects into the params
  const addParams = (obj?: object) => {
    if (!obj) return;
    Object.entries(obj).forEach(([key, value]) => {
      // Convert camelCase to snake_case
      const snakeKey = key?.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
      const stringValue: string | undefined = value && Array.isArray(value) ? value.join(',') : value?.toString();
      if (stringValue !== undefined && stringValue !== null && stringValue !== '') {
        params = params.set(snakeKey, stringValue as string);
      }
    });
  };

  addParams(request);

  return params;
};
